import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "react-bootstrap-typeahead/css/Typeahead.css";
import "./styling/bootstrap4-main.scss";
import "./styling/bootstrap3-scoped.css";
import { IConfig } from "./lib/config";

declare global {
  interface Window {
    zEmbed?: {
      (callback: () => void): void;
      activate(activate: boolean): void;
      setLocale(locale: string): void;
    };
    FreshworksWidget?: any;
    CONFIG?: IConfig;
  }
}

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
